import { Switch } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

import useChangeTheme from 'hooks/useChangeTheme';

export default function ToggleTheme() {
  const theme = useTheme();
  const changeTheme = useChangeTheme();

  const handleChangeThemeType = () => {
    const nextPaletteType = theme.palette.type === 'dark' ? 'light' : 'dark';
    changeTheme({ type: 'CHANGE', payload: { paletteType: nextPaletteType } });
  };

  return (
    <Switch
      edge="end"
      size="small"
      color="primary"
      onChange={handleChangeThemeType}
      checked={theme.palette.type === 'dark'}
      inputProps={{ 'aria-labelledby': 'settings-theme-type' }}
    />
  );
}
